import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
   
  constructor( private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    let url: string = state.url;

    return this.checkLogin(url);
    // return true;
  }
  

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  checkLogin(url: string): true | UrlTree {
    const loginCookie = this.getCookie("loginStatus");
    const currentUser = localStorage.getItem('currentUser');
    const hasSession = loginCookie === "1" && !!currentUser;

    if (hasSession) {
      if (url === "/login" || url.startsWith("/login?")) {
        return this.router.parseUrl('/resources');
      }
      return true;
    }

    // Stale cookie/token mismatch — clear so the user can log in cleanly
    if (loginCookie === "1" && !currentUser) {
      document.cookie.split(';').forEach((cookie) => {
        const name = cookie.split('=')[0].trim();
        if (name) {
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        }
      });
      localStorage.removeItem('currentUser');
    }

    return this.router.parseUrl('/login');
  }
}
